import * as yup from "yup";

const MIN_LIMIT_VALUE = 0;
const MAX_LIMIT_VALUE = 999999999;

export const defaultLimitValueValidator = yup
  .number()
  .integer("Value must be an integer")
  .min(MIN_LIMIT_VALUE, "Value must be greater or equal to ${min}")
  .max(MAX_LIMIT_VALUE, "Value must be less or equal to ${max}")
  .required("Value is required");

export const templateLimitValueValidator = yup
  .number()
  .integer("Value must be an integer")
  .min(0, "Value must be greater or equal to ${min}")
  .max(MAX_LIMIT_VALUE, "Value must be less or equal to ${max}")
  .required("Value is required");
